import React, { Component } from "react"
import Modal from "react-bootstrap/lib/Modal"
import TagSelect from "../tag_select"
import BarChart from "../bar_chart"
import RangeSelector from "../range_selector"
import TeamSigil from "../team_sigil"
import {
    generateQueries,
    toHours,
    toBarChartData,
    toUserData,
    secondsToHours,
} from "../../common/components/modals/tag_report_modal"
import * as dateUtils from "../../util/date_utils"
import Avatar from "../avatar"
import { ExportReportSelector } from "../export_report_selector"
import ReportOptions from "../report_options"

class TagReportModal extends Component {
    constructor(props) {
        super(props)

        this.renderBigTag = this.renderBigTag.bind(this)
        const { now, interval = "Week" } = this.props
        this.state = {
            reportOption: localStorage.getItem("reportOption"),
            reportTags: [],
            primed: false,
            reportRange: {
                // eslint-disable-line no-unused-vars
                increment: interval,
                interval: interval,
                subInterval: dateUtils.subIntervalFor(interval),
                ...dateUtils.getDefaultTimespanBackward(
                    interval,
                    (now || new Date()).getTime(),
                ),
            },
        }
    }

    componentDidMount() {
        const { initialReportTag } = this.props
        const bigTagsMeta = initialReportTag ? [initialReportTag] : []
        this.setState(
            { reportTags: bigTagsMeta, primed: true },
            this.performQueries,
        )
    }

    componentWillReceiveProps(nextProps) {
        const { reportTags, primed } = this.state
        const { initialReportTag, user } = nextProps

        if (reportTags.length === 0 && initialReportTag && !primed) {
            const bigTagsMeta = [...reportTags, initialReportTag]
            this.setState(
                { reportTags: bigTagsMeta, primed: true },
                this.performQueries,
            )
            return
        }

        if (reportTags.length === 0 && user && !primed) {
            this.setState({ reportTags: [], primed: true }, this.performQueries)
            return
        }
    }

    currentSpanStart = () => {
        const { start } = this.state.reportRange
        return new Date(start)
    }

    performQueries = () => {
        const { queryTagReports, team, user } = this.props
        const { reportTags, reportRange } = this.state
        const tagIds = reportTags.map(t => t.id)
        const now = this.currentSpanStart()
        const queries = generateQueries(
            now,
            reportRange,
            tagIds,
            reportRange.interval,
            user ? user.id : undefined,
        )
        const { reportOption } = this.state

        if (queries.length > 0) {
            queryTagReports(
                {
                    queries: [...queries],
                    team,
                    reportOption,
                })
        }
    }

    updateReportTags = reportTags => {
        this.setState({ reportTags: reportTags }, this.performQueries)
    }

    updateReportOption = reportOption => {
        this.setState({ reportOption }, this.performQueries)
    }

    removeReportTag = id => {
        const { reportTags } = this.state
        const updatedTags = reportTags.filter(tag => tag.id !== id)
        this.setState({ reportTags: updatedTags }, this.performQueries)
    }

    renderBigTag({ name, color, teamId, id, teamSigil }) {
        const { teams } = this.props
        const sigil = TeamSigil(teams[teamId], teamSigil)
        return (
            <div className="big-report-tag" style={{ backgroundColor: color }}>
                <div className="big-report-tag-caption">
                    {sigil}
                    {name}
                </div>
                <div
                    className="big-report-tag-status"
                    onClick={() => this.removeReportTag(id)}
                >
                    <span className="big-report-tag-close">
                        <i className="fa fa-times fa-lg" aria-hidden="true"></i>
                    </span>
                </div>
            </div>
        )
    }

    addTag = () => {
        this.setState({ showTagSelect: true })
    }

    handleSelect = ([increment, interval]) => {
        const selectedInterval = interval === "This Week" ? "Week" : interval
        const subInterval = dateUtils.subIntervalFor(selectedInterval)
        const now =
            interval === "This Week" ? new Date() : this.currentSpanStart()
        const newSpan = dateUtils.getDefaultTimespanBackward(
            selectedInterval,
            now,
        )
        this.setState(
            {
                reportRange: {
                    ...newSpan,
                    increment,
                    interval: selectedInterval,
                    subInterval,
                },
            },
            this.performQueries,
        )
    }

    moveForward = () => {
        const {
            interval,
            increment,
            subInterval,
            ...span
        } = this.state.reportRange
        const oneForward = dateUtils.moveSpan(span, increment, 1)

        this.setState(
            {
                reportRange: {
                    ...oneForward,
                    increment,
                    interval,
                    subInterval,
                },
            },
            this.performQueries,
        )
    }

    moveBackward = () => {
        const {
            interval,
            increment,
            subInterval,
            ...span
        } = this.state.reportRange
        const oneBackward = dateUtils.moveSpan(span, increment, -1)

        this.setState(
            {
                reportRange: {
                    ...oneBackward,
                    increment,
                    interval,
                    subInterval,
                },
            },
            this.performQueries,
        )
    }

    intervalToHours = reportId => {
        const { tagReports } = this.props
        return toHours(tagReports.items[reportId])
    }

    getExportParams = () => {
        const { start: startsBy, end: endsBy } = this.state.reportRange
        const tagIds = this.state.reportTags
            ? this.state.reportTags.map(t => t.id).join(",")
            : ""
        const params = {
            startsBy,
            endsBy,
            tagIds,
            tagFilterType: this.state.reportOption,
        }

        // optional params
        const { user, team } = this.props
        if (user) {
            params["ownerId"] = user.id
        }

        if (team) {
            params["teams"] = team.id
        }

        return params
    }

    render() {
        const {
            toggleTagReport,
            teams,
            recentTagCombos,
            tags,
            initialReportTag,
            tagReports,
            user,
            teamMembers = [],
            downloadCsv,
            pushReportToZapier,
            webhookSubscriptions,
        } = this.props
        const { reportTags, reportRange } = this.state
        const { interval, subInterval, ...span } = this.state.reportRange
        const barChartData = toBarChartData(tagReports, subInterval)
        const userData = toUserData(tagReports, subInterval)
        const title = dateUtils.dateRangeString(interval, span, {
            short: true,
            hideYear: interval !== "Month",
        })

        //params for export-report-selector
        const exportParams = this.getExportParams()

        // always show the year
        const showThisYear = true
        const showThisMonth = interval !== "Year"
        const showThisWeek = interval === "Week"

        const rangeMidpoint =
            reportRange.start + (reportRange.end - reportRange.start) / 2
        const rangeMidpointDate = new Date(rangeMidpoint)

        const week = dateUtils.getDefaultTimespan("Week", rangeMidpoint)
        const weekLbl = dateUtils.isThisWeek(rangeMidpointDate)
            ? "This Week"
            : dateUtils.dateRangeString("Week", week, {
                short: true,
                hideYear: true,
            })
        const month = dateUtils.getDefaultTimespan("Month", rangeMidpoint)
        const monthLbl = dateUtils.isThisMonth(rangeMidpointDate)
            ? "This Month"
            : dateUtils.dateRangeString("Month", month, {
                short: false,
                hideYear: true,
            })
        const year = dateUtils.getDefaultTimespan("Year", rangeMidpoint)
        const yearLbl = dateUtils.isThisYear(rangeMidpointDate)
            ? "This Year"
            : dateUtils.dateRangeString("Year", year)

        const getValue = (data, member) => {
            const rec = (userData[member.id] || []).find(
                d => d.label === data.label,
            )
            return rec ? rec.value : 0
        }

        const getTotal = member => {
            return (userData[member.id] || [])
                .reduce((acc, d) => acc + d.value, 0)
                .toFixed(2)
        }

        const filteredMembers = teamMembers.filter(
            member => member.isActive || getTotal(member) > 0,
        )

        return (
            <Modal
                dialogClassName="tag-report"
                className="modal-v2"
                show={true}
                onHide={toggleTagReport}
                animation={false}
            >
                <Modal.Header closeButton>
                    {user && (
                        <Avatar
                            emailAddress={user.primaryEmail}
                            name={user.name}
                            showTooltip={true}
                        />
                    )}
                    <TagSelect
                        recentTagCombos={recentTagCombos}
                        tags={Object.values(tags.items)}
                        tagMap={tags.items}
                        teams={teams}
                        values={reportTags}
                        onValuesChange={this.updateReportTags}
                        placeholder="Tags"
                        autofocus={false}
                        allowCreate={false}
                        renderValue={this.renderBigTag}
                        anchor={initialReportTag}
                    />
                    <ReportOptions 
                        reportOption={this.state.reportOption}
                        setReportOption={this.updateReportOption}
                    />
                </Modal.Header>
                <Modal.Body id="modal-body">
                    <div className="report-container">
                        {showThisWeek && (
                            <div className="report-counter">
                                <span className="report-counter-val">
                                    {this.intervalToHours("thisWeek")}
                                </span>
                                {weekLbl}
                            </div>
                        )}
                        {showThisMonth && (
                            <div className="report-counter report-counter-middle">
                                <span className="report-counter-val">
                                    {this.intervalToHours("thisMonth")}
                                </span>
                                {monthLbl}
                            </div>
                        )}
                        {showThisYear && (
                            <div className="report-counter">
                                <span className="report-counter-val">
                                    {this.intervalToHours("thisYear")}
                                </span>
                                {yearLbl}
                            </div>
                        )}
                    </div>
                    <div className="tag-report-nav">
                        <RangeSelector
                            title={title}
                            onSelect={this.handleSelect}
                            onClickForward={this.moveForward}
                            onClickBackward={this.moveBackward}
                            defaultSelectedOption={"Week"}
                            options={[
                                { key: ["Week", "Week"], label: "Week" },
                                { key: ["Month", "Month"], label: "Month" },
                                { key: ["Year", "Year"], label: "Year" },
                                {
                                    key: ["Week", "This Week"],
                                    label: "This Week",
                                },
                            ]}
                        />
                    </div>
                    <div className="report-container report-graph">
                        <BarChart data={barChartData} valueLabel="hours" />
                    </div>
                    <div className="report-entries-header">
                        <ExportReportSelector
                            downloadCsv={downloadCsv}
                            pushReportToZapier={pushReportToZapier}
                            exportParams={exportParams}
                            webhookSubscriptions={webhookSubscriptions}
                        />
                    </div>
                    {filteredMembers && filteredMembers.length > 1 && !user && (
                        <div className="report-entries">
                            <table>
                                <tr>
                                    <td className="date-col header">Date</td>
                                    {filteredMembers.map((member, i) => (
                                        <td className="data-col header" key={i}>
                                            <Avatar
                                                showTooltip={true}
                                                name={member.fullName}
                                                emailAddress={
                                                    member.primaryEmail
                                                }
                                            />
                                        </td>
                                    ))}
                                </tr>

                                <tr>
                                    <td className="date-col">
                                        <b>Total</b>
                                    </td>
                                    {filteredMembers.map((member, i) => (
                                        <td className="data-col" key={i}>
                                            <b>
                                                {secondsToHours(
                                                    getTotal(member),
                                                )}
                                            </b>
                                        </td>
                                    ))}
                                </tr>

                                {barChartData.map((data, i) => (
                                    <tr key={i}>
                                        <td className="date-col">
                                            {data.label}
                                        </td>
                                        {filteredMembers.map((member, i) => (
                                            <td className="data-col" key={i}>
                                                {secondsToHours(
                                                    getValue(data, member),
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </table>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        )
    }
}

export default TagReportModal



// WEBPACK FOOTER //
// ./src/components/modals/tag_report_modal.jsx